import type { ReactNode } from "react";

const URL_PATTERN =
  /(?:https?:\/\/|www\.)[^\s<>"'`]+[^\s<>"'`.,;:!?)\]}…)】」』]/gi;

function normalizeUrl(raw: string) {
  return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
}

export function linkify(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let index = 0;
  for (const match of text.matchAll(URL_PATTERN)) {
    const start = match.index ?? 0;
    if (start > index) nodes.push(text.slice(index, start));
    const label = match[0];
    nodes.push(
      <a
        key={`${start}-${label}`}
        href={normalizeUrl(label)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </a>,
    );
    index = start + label.length;
  }
  if (index < text.length) nodes.push(text.slice(index));
  return nodes;
}
